export default [
  {
    path: '/race/:race_id(\\d+)',
    name: 'race',
    component: () => import('@/views/race/detail.vue'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/race/:race_id(\\d+)/profile',
    name: 'raceprofile',
    component: () => import('@/views/race/profile.vue')
  }
]
